/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import {
  ButtonSizes,
  PrimaryButton,
} from 'common/components/controls/button/button';
// eslint-disable-next-line no-restricted-imports
import { forNamespace } from 'common/lib/util/i18n';
import React from 'react';

import styles from './popover-confirm.less';

export interface PopoverConfirmProps {
  confirmKey: string;
  confirmCallback: React.MouseEventHandler;
}

const PopoverConfirm: React.FunctionComponent<PopoverConfirmProps> = ({
  confirmKey,
  confirmCallback,
}) => {
  const format = forNamespace(['confirm', confirmKey]);

  return (
    <div className={styles.confirmContainer}>
      <p>{format('text')}</p>
      <PrimaryButton
        autoFocus
        onClick={confirmCallback}
        size={ButtonSizes.FULLWIDTH}
      >
        {format('confirm')}
      </PrimaryButton>
    </div>
  );
};

export default PopoverConfirm;



// WEBPACK FOOTER //
// ./app/gamma/src/components/popover/popover-confirm.tsx